/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FantaLineupCreate } from '../models/FantaLineupCreate';
import type { FantaMatchDay } from '../models/FantaMatchDay';
import type { FantaMatchDaySmall } from '../models/FantaMatchDaySmall';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FantaMatchService {
    /**
     * Get Fanta Match By Match Day And Team
     * Get a specific Fanta match by its ID.
     * @param fantaTeamId
     * @param matchDay
     * @returns FantaMatchDay Successful Response
     * @throws ApiError
     */
    public static getFantaMatchByMatchDayAndTeamId(
        fantaTeamId: number,
        matchDay: number,
    ): CancelablePromise<FantaMatchDay> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/fanta_match/match_day/{match_day}/team/{fanta_team_id}',
            path: {
                'fanta_team_id': fantaTeamId,
                'match_day': matchDay,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Fanta Matchdays By Team
     * @param fantaTeamId
     * @returns FantaMatchDaySmall Successful Response
     * @throws ApiError
     */
    public static getFantaMatchdaysByTeam(
        fantaTeamId: number,
    ): CancelablePromise<Array<FantaMatchDaySmall>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/fanta_match/team/{fanta_team_id}',
            path: {
                'fanta_team_id': fantaTeamId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Update Fanta Lineup
     * @param fantaTeamId
     * @param matchDay
     * @param requestBody
     * @returns FantaMatchDay Successful Response
     * @throws ApiError
     */
    public static createUpdateFantaLineup(
        fantaTeamId: number,
        matchDay: number,
        requestBody: FantaLineupCreate,
    ): CancelablePromise<FantaMatchDay> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/fanta_match/lineup/{fanta_team_id}',
            path: {
                'fanta_team_id': fantaTeamId,
            },
            query: {
                'match_day': matchDay,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
